import { NgModule } from '@angular/core';
import { environment } from '../environments/environment';
import { RouterModule, Routes } from '@angular/router';
import { CommunityGuard } from './guards/community.guard';
import { RedirectGuard } from './guards/redirect.guard';
import { HomeComponent } from './components/home/home.component';
import { CommandComponent } from '@common/components/command/command.component';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'shutoken' },
    {
        path: ':community',
        canActivate: [RedirectGuard, CommunityGuard],
        data: {
            isProduction: environment.production,
        },
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', component: HomeComponent },
            {
                path: 'info',
                loadChildren: () =>
                    import('./components/info/info.module').then(
                        (mod) => mod.InfoModule,
                    ),
            },
            {
                path: 'faq',
                loadChildren: () =>
                    import('./components/faq/faq.module').then(
                        (mod) => mod.FaqModule,
                    ),
            },
            {
                path: 'contact',
                loadChildren: () =>
                    import('./components/contact/contact.module').then(
                        (mod) => mod.ContactModule,
                    ),
            },
            {
                path: 'register',
                loadChildren: () =>
                    import('./components/register/register.module').then(
                        (mod) => mod.RegisterModule,
                    ),
            },
            {
                path: 'suppliers',
                loadChildren: () =>
                    import('./components/supplier/supplier.module').then(
                        (mod) => mod.SupplierModule,
                    ),
            },
            {
                path: 'error',
                loadChildren: () =>
                    import('./components/error/error.module').then(
                        (mod) => mod.ErrorModule,
                    ),
            },
            {
                path: 'cookie-policy',
                loadChildren: () =>
                    import(
                        './components/cookie-policy/cookie.policy.module'
                    ).then((mod) => mod.CookiePolicyModule),
            },
            {
                path: 'terms-and-conditions',
                loadChildren: () =>
                    import(
                        './components/terms-and-conditions/terms-and-conditions.component.module'
                    ).then((mod) => mod.TermsAndConditionsModule),
            },
            {
                path: 'privacy-policy',
                loadChildren: () =>
                    import(
                        './components/privacy-policy/privacy-policy.component.module'
                    ).then((mod) => mod.PrivacyPolicyComponentModule),
            },
            {
                path: 'do/:id/:command',
                component: CommandComponent,
            },
            {
                path: 'unauthorized',
                loadChildren: () =>
                    import(
                        './components/unauthorized/unauthorized.module'
                    ).then((mod) => mod.UnauthorizedModule),
            },
            { path: '**', redirectTo: 'home' },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
